import { render, staticRenderFns } from "./DesignSubmission.vue?vue&type=template&id=d2e84e26&"
import script from "./DesignSubmission.vue?vue&type=script&lang=js&"
export * from "./DesignSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports